export const paths = {
  public: {
    index: '/',
    login: {
      index: '/login',
      checkToken: '/login/checkToken'
    }
  },
  authenticated: {
    index: '/',
    home: '/home',
    settings: {
      index: '/settings'
    },
    bids: {
      index: '/bids',
      biddetail: '/bids/:bidId',
      bidnew: '/bids/new'
    },
    contracts: {
      index: '/contracts',
      contractnew: '/contracts/new',
      contractdetail: '/contracts/:contractId',
      projectusers: '/contracts/:contractId/users',
      certifylist: '/contracts/:contractId/certifyList',
      certifylistdetail: '/contracts/:contractId/certifyList/:certificationId',
      vendorassignmentdetail: '/contracts/:contractId/vendorAssignments/:assignmentId'
    },
    contractorCertification: {
      certify: '/certifyList/:certificationId'
    },
    vendors: {
      index: '/vendorSearch',
      vendordetails: '/vendorDetail/:vendorId'
    },
    reports: {
      index: '/reports',
      designer: '/reports/design'
    },
    app: {
      index: '/app',
      users: '/app/users',
      userDetail: '/app/users/:userId'
    },
    notifications: {
      index: '/notifications',
      notificationdetail: '/notifications/:notificationId'
    }
  },
};